import { FaSearch, FaTimes } from "react-icons/fa";
import { useNoAutofill } from "../../_CORE/APP/Hooks/Hooks/useNoAutofill";
import "./_Styles/SearchFilter.css";

export const onNormalizeText = (value) => String(value ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

export const onMatchesSearch = (search, values = []) => {

    const TERM = onNormalizeText(search).trim();

    if (!TERM) return true;

    // Busqueda multi-palabra: "react hooks" puede coincidir aunque cada palabra
    // viva en un campo distinto (titulo, descripcion, stack, estado, etc.).
    const TOKENS = TERM.split(/\s+/).filter(Boolean);
    const HAYSTACK = values.map(onNormalizeText).join(" ");

    return TOKENS.every((token) => HAYSTACK.includes(token));
};

export const SearchFilter = ({ value, onChange, placeholder = "Buscar…", total = null, matches = null }) => {

    const onNoAutofill = useNoAutofill({ hard: true });

    return (
        <div className="LStudio__app_search">

            <span className="LStudio__app_search_icon"><FaSearch /></span>

            <input {...onNoAutofill("search")} type="search" className="LStudio__app_search_input"
                placeholder={placeholder} value={value}
                onChange={(event) => onChange(event.target.value)} />

            {
                !!value && (
                    <>
                        {
                            matches !== null && total !== null && (
                                <span className="LStudio__app_search_count">{matches} de {total}</span>
                            )
                        }

                        <button type="button" className="LStudio__app_search_clear"
                            onClick={() => onChange("")} aria-label="Limpiar búsqueda">
                            <FaTimes />
                        </button>
                    </>
                )
            }

        </div>
    );
};
